<template>
  <v-alert
    outlined
    text
    width="100%"
    :type="type"
    :color="color"
    :dismissible="dismissible"
    class="mb-2"
  >
    <div class="d-flex justify-space-between">
      <span v-if="resolvedContent" class="grey-font text-h4">{{ resolvedContent }}</span>
      <span v-else-if="resolvedHtmlContent" v-html="resolvedHtmlContent" class="grey-font text-h4" />

      <v-btn
        v-if="details"
        small
        text
        :ripple="false"
        class="non-text-transformation show-details-btn"
        @click="toggleShowDetails"
      >
        {{ showDetails ? $t('ALERT_HIDE_DETAILS') : $t('ALERT_SHOW_DETAILS') }}
        <v-icon small>mdi-chevron-{{ showDetails ? 'up' : 'down' }}</v-icon>
      </v-btn>
    </div>

    <div v-if="details && showDetails" class="grey-font body-2">
      <div class="font-weight-bold">{{ $t('ALERT_DETAILS_LABEL') }}</div>
      <div>{{ details }}</div>
    </div>

    <template v-if="dismissible" v-slot:close="{ toggle }">
      <v-icon small @click="close(toggle)">mdi-close</v-icon>
    </template>
  </v-alert>
</template>

<script>
import { mapMutations } from 'vuex'

const COLOR_MAP = {
  info: 'info',
  error: 'primary',
  success: null,
}

export default {
  name: 'Alert',
  props: {
    id: {
      type: String,
    },
    type: {
      type: String,
      default: function() {
        return 'success'
      },
      validator: function(value) {
        return ['success', 'error', 'info'].indexOf(value) !== -1
      },
    },
    dismissible: {
      type: Boolean,
    },
    content: {
      type: String,
    },
    htmlContent: {
      type: String,
    },
    contentKey: {
      type: String,
    },
    htmlContentKey: {
      type: String,
    },
    htmlContentParams: {
      type: Object,
    },
    details: {
      type: [String, Error],
    },
  },
  data() {
    return {
      COLOR_MAP,
      showDetails: false,
    }
  },
  computed: {
    color() {
      return this.COLOR_MAP[this.type]
    },
    resolvedContent() {
      if (this.contentKey) return this.$t(this.contentKey)
      return this.content
    },
    resolvedHtmlContent() {
      if (!this.htmlContentKey) return this.htmlContent
      const params = {}
      Object.entries(this.htmlContentParams || {}).forEach(([k, v]) => {
        params[k.endsWith('Key') ? k.slice(0, -3) : k] = k.endsWith('Key') ? this.$t(v) : v
      })
      return this.$t(this.htmlContentKey, params)
    },
  },
  methods: {
    ...mapMutations('alerts', ['removeAlert']),
    close(toggle) {
      toggle()
      if (this.id) {
        this.removeAlert(this.id)
      }
    },
    toggleShowDetails() {
      this.showDetails = !this.showDetails
    },
  },
}
</script>

<style scoped lang="scss">
.show-details-btn:hover::before {
  opacity: 0 !important;
}
</style>
